<template>
  <div 
    data-div="dadosDevolucao"
    id="dadosDevolucao" 
    @click="$emit('close')"
    style="display: block; padding-top: 50px;" 
    class="w3-modal" 
    v-cloak>
    
    <div class="w3-modal-content"  @click.stop v-cloak>
      <header class="" v-cloak>
        <span @click="$emit('close')" class="w3-button w3-display-topright">&times;</span>
        <h5 class="texto-vermelho titulo">Dados da Devolução</h5>
      </header>
      
      <div>
        <div class="w3-col s12 l4 w3-text-theme">
          <strong>{{devolucao.requisicao_id}}</strong>
        </div>
        
        <div class="w3-col">
          <strong class="w3-text-green">R$ {{devolucao.valor_devolucao}}</strong>
        </div>

        <div class="w3-col">
          <legenda>
            <span>Nome do cliente</span>
            <i slot="referencia" class="fa fa-user-tag w3-text-theme"></i>
          </legenda>
          <strong>{{devolucao.nome_cliente}}</strong>
        </div>
        
        <div class="w3-col s12 l8">
          <legenda>
            <span>Nome da empresa</span>
            <i slot="referencia" class="fa fa-building w3-text-theme"></i>
          </legenda>
          <strong>{{devolucao.empresa}}</strong>
        </div>
        
        <div class="w3-col">
          <h6 
            @click="alternarMostrarDetalhes(0, 'DADOS_GERAIS')"
            v-if="!mostrar_dados_gerais" 
            class="fundo-cabecalho">&nbsp;
            <span>
              <i class="fas fa-sort"/>
            </span>&nbsp;
            <i class="fas fa-file-invoice-dollar"/>&nbsp;
            <a href="#">Dados gerais</a>
          </h6>
              
          <h6 
            @click="alternarMostrarDetalhes(0, 'DADOS_GERAIS')" 
            v-if="mostrar_dados_gerais" 
            class="fundo-cabecalho">&nbsp;
            <span>
              <i class="fas fa-sort-down"/>
            </span>&nbsp;
            <i class="fas fa-file-invoice-dollar"/>&nbsp;
            <a href="#">Dados gerais</a>
          </h6>
        </div>
        
        <div v-if="mostrar_dados_gerais">
          <div class="w3-col s12 l4" v-if="devolucao.data_devolucao != devolucao.data_devolucao">
            <legenda>
              <span>Data cadastro</span>
              <i slot="referencia" class="fa fa-calendar w3-text-theme"></i>
            </legenda>
            &nbsp;Cadastro:</label>
            <strong>{{devolucao.data_cadastro}}</strong>
          </div>
  
          <div class="w3-col s12 l4">
            <legenda>
              <span>Data devolução</span>
              <i slot="referencia" class="fa fa-calendar w3-text-theme"></i>
            </legenda>
            &nbsp;Devolução:</label>
            <strong>{{devolucao.data_devolucao}}</strong>
          </div>
  
          <div class="w3-col s12 l4">
            <label>Devolução total:</label>
            <strong>{{devolucao.devolucao_total}}</strong>
          </div>
  
          <div class="w3-col s12 l4">
            <label>Devolução automática:</label>
            <strong>{{devolucao.devolucao_automatica}}</strong>
          </div>
  
          <div class="w3-col s12 l4">
            <label>Gerou crédito:</label>
            <strong>{{devolucao.gerar_credito}}</strong>
          </div>
  
          <div class="w3-col s12 l4">
            <label>Pedido:</label>
            <strong class='w3-text-blue'>{{devolucao.orcamento_id}}</strong>
          </div>
            
          <div class="w3-col s12 l4" v-if="devolucao.financeiro_id != 0">
            <label>Crédito gerado:</label>
            <strong class='w3-text-blue'>{{devolucao.financeiro_id}}</strong>
          </div>
  
          <div class="w3-col s12 l4" v-if="devolucao.turno">
            <label>Turno:</label>
            <strong class='w3-text-blue'>{{devolucao.turno}}</strong>
          </div>
        </div>
      

        <div class="w3-col s12 l12">
          <h6 
            @click="alternarMostrarDetalhes(0, 'ITENS')"
            v-if="!mostrar_itens" 
            class="fundo-cabecalho">&nbsp;
            <span>
              <i class="fas fa-sort"/>
            </span>&nbsp;
            <i class="fas fa-shopping-cart"/>&nbsp;
            <a href="#">Itens da devolução</a>
          </h6>
              
          <h6 
            @click="alternarMostrarDetalhes(0, 'ITENS')"
            v-if="mostrar_itens" 
            class="fundo-cabecalho">&nbsp;
            <span>
              <i class="fas fa-sort-down"/>
            </span>&nbsp;
            <i class="fas fa-shopping-cart"/>&nbsp;
            <a href="#">Itens da devolução</a>
          </h6>
        
          <div 
            data-div="itens"
            v-if="mostrar_itens"
            style="padding:0px"
            class="w3-container w3-small">
          
            <div 
              :key="index"
              class="card-item w3-container"
              @click="alternarMostrarDetalhes(index, 'ITEM')"
              :style="getStyleFundoCardExpandido(item.mostrar_detalhes)"
              v-for="(item, index) in itens">
              
              <div class="w3-col s12">
                <strong class="w3-text-theme">{{item.produto_id}} - {{item.nome_produto}} - {{item.unidade}}</strong>
              </div> 
                
              <div class="w3-col s12">
                <label>Marca: </label>
                <strong>{{item.nome_marca}}</strong>
              </div>

              <div class="w3-col s12" v-show="!item.mostrar_detalhes">
                <label>Total:</label>
                <strong class="w3-text-green">R$ {{item.total}}</strong>
              </div>  

              <div class="w3-col s12 w3-center" v-show="!item.mostrar_detalhes">
                <i style="color: #7a7a7a;" class="fas fa-ellipsis-h"/>
              </div>

              <div v-show="item.mostrar_detalhes">

                <div class="w3-col s12 ">
                  <label>Quantidade:</label>
                  <strong>{{item.quantidade}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Preço de venda:</label>
                  <strong>R$ {{item.preco_venda}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Total:</label>
                  <strong class="w3-text-green">R$ {{item.total}}</strong>
                </div> 

                <div class="w3-col s12" v-show="item.lote">
                  <label>Lote: </label>
                  <strong>{{item.lote}}</strong>
                </div> 

                <div class="w3-col s12" v-show="item.vencimento">
                  <label>Vencimento: </label>
                  <strong>{{item.vencimento}}</strong>
                </div> 

                <div class="w3-col s12" v-show="item.local">
                  <label>Local:</label>
                  <strong>{{item.local}}</strong>
                </div>

                <div class="w3-col s12">
                  <label>Origem:</label>
                  <strong>{{item.origem_analitico}}</strong>
                </div> 

              </div>
            </div>
          </div>
        </div>
      </div> 
      
      <footer data-div='footer' class="w3-container conteudo-centralizado">
        <button 
          class="w3-btn w3-theme" 
          id="btn-confirmar-acao" 
          style="margin-top: 10px; margin-bottom:10px"
          @click="$emit('close')">
          <i class="fas fa-check-circle"/> Ok
        </button>
      </footer> 
    </div>                                
  </div>
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin.js'
  import legenda from '@/components/Legendas'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarDadosOrcamento from '@/components/Rest/ROrcamento/ROrcamentoBuscarDadosDevolucao.js'
  
  export default {
    name: 'dadosDevolucao',
    props: ['devolucao_dados'],
    mixins:[formatarValorMixin],
    components:{legenda},

    data() {
      return {
        api: process.env.API,
        devolucao: {},
        itens: [],
        mostrar_itens: true,
        mostrar_dados_gerais: true
      }
    },

    mounted() {
      this.preencherDadosDevolucao(); 
    },

    methods: {
      mostrarDadosGerais(){
        this.mostrar_dados_gerais = !this.mostrar_dados_gerais;
      },
      
      mostrarItens(){
        this.mostrar_itens = !this.mostrar_itens;
      },
      
      alternarMostrarDetalhes(index, tipo){
        if (tipo == 'ITENS'){
          this.mostrar_itens = !this.mostrar_itens;
        } else if (tipo == 'DADOS_GERAIS'){
          this.mostrar_dados_gerais = !this.mostrar_dados_gerais;
        } else if (tipo == 'ITEM'){
          this.itens[index].mostrar_detalhes = !this.itens[index].mostrar_detalhes;;
        } 

        this.$forceUpdate();
      },

      getStyleFundoCardExpandido(mostrar_detalhes){
        return mostrar_detalhes ? 'border: 1px solid #bfbfbf; box-shadow: #7a7a7a 1px 2px 5px 2px;' : 'background-color: white';
      },

      async preencherDadosDevolucao(){
        try {

          let parametros = {
            devolucao_id: this.devolucao_dados  
          }

          let retorno = await ROrcamentoBuscarDadosOrcamento.buscarDadosDevolucao(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }
          
          this.devolucao = retorno.dados.devolucao;
          this.itens = retorno.dados.itens;
        } catch (error) {
          Biblioteca.gerarLogNomeFuncao('DadosDevolucao.vue -> preencherDadosDevolucao');
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);
        }
      }
    },
  }
</script>

<style scoped>

  .w3-card {
    padding: 10px;
    box-shadow: none !important;
  }
  .cabecalho > .w3-col > input{
    padding: 1px 5px
  }
  .cabecalho {
    white-space: nowrap;
  }
  
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  
  ::-webkit-scrollbar-track {
    background: #ddd; 
  }
    
  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }
    
  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }
  
  .card-item {
    margin-top: 0 !important
  }
  
  .card-produto {
    margin-top: 0 !important;
    white-space: normal
  }
  
  .fundo-cabecalho {
    background-color: #9c1d1c;
    color: white;
    margin-left: 2px;
    border-radius: 5px;
    font-size: 14px;
  }
  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%
  }
  
  .card-informacoes-selecionado {
    border-left-color : #a20000 !important
  }
  
  .card-informacoes:hover {
    background: #eeeeee
  }
  
  .label-itens {
    white-space: nowrap;
    text-align:center;
  }
  
  .cor-produto {
    background: #871a1a;
    color: white;
  }
  
  .th-items {
    white-space: nowrap;
  }
  
  .items > td {
    text-align: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/Orcamentos/DadosDevolucao.vue